import { render, staticRenderFns } from "./Msg.vue?vue&type=template&id=4048aea4&scoped=true"
import script from "./Msg.vue?vue&type=script&lang=js"
export * from "./Msg.vue?vue&type=script&lang=js"
import style0 from "./Msg.vue?vue&type=style&index=0&id=4048aea4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4048aea4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4048aea4')) {
      api.createRecord('4048aea4', component.options)
    } else {
      api.reload('4048aea4', component.options)
    }
    module.hot.accept("./Msg.vue?vue&type=template&id=4048aea4&scoped=true", function () {
      api.rerender('4048aea4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/skinSetting/components/Msg.vue"
export default component.exports